const controlValueLabels: Record<string, string> = {
  ALLOW: "Allow",
  READ_ONLY: "Read only",
  BLOCK: "Block",
  HOLD: "Hold for review",
  PAUSE: "Pause",
  GRACEFUL_LOCK: "Graceful lock",
  REVOKE_NOW: "Revoke now",
  NOW: "Immediately",
  SCHEDULED: "Scheduled",
  RULEZERO_MANUAL: "Rulezero manual",
  SECURITY_INCIDENT: "Security incident",
  COMPLIANCE_REVIEW: "Compliance review",
  OTHER_RULEZERO_APPROVED: "Other Rulezero approved",
};

export function displayOperationalControlValue(value?: string | null): string {
  if (!value) return "";
  if (controlValueLabels[value]) return controlValueLabels[value];

  return value
    .toLowerCase()
    .split("_")
    .map((word, index) =>
      index === 0 || word === "rulezero"
        ? `${word.charAt(0).toUpperCase()}${word.slice(1)}`
        : word
    )
    .join(" ");
}
